import {createStore, applyMiddleware} from "redux";
import {persistStore, persistReducer} from "redux-persist";
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
// import AsyncStorage from "@react-native-async-storage/async-storage";
import thunk from "redux-thunk";

import reducer from "./reducer";

const persistConfig = {
  key: "root",
  storage: storage,
  blacklist: ['mainMenuReducer']
};

const persistedReducer = persistReducer(persistConfig, reducer);

const store = createStore(persistedReducer, applyMiddleware(thunk));

const persistor = persistStore(store);

const x = {
  store,
  persistor,
};
export default x;
